"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createPrivateStorage = createPrivateStorage;
function createPrivateStorage() {
	const wm = new WeakMap();
	return self => {
		let obj = wm.get(self);
		if (obj) {
			return obj;
		} else {
			obj = Object.create(null);
			wm.set(self, obj);
			return obj;
		}
	};
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@petamoriken/float16/lib/private.js
// module id = 137
// module chunks = 0